import * as colors from 'assets/theme/colors';
import {makeStyles} from '@material-ui/core/styles';

export const useButtonStyles = makeStyles((theme) => ({
    delete: {
        width: '100%',
        height: '100%',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        fontSize: theme.typography.pxToRem(14),
        backgroundColor: `${colors.neutrals.A10} !important`,
        boxShadow: theme.shadows[4],
        borderRadius: '0% !important',
    },
}));
